import src from "IMAGE";
export default { src, width: 253, height: 65, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ACUlJdkkJCTEBAQEPwwMDGoMDQ1sDg8PgAwMDGoMDQ1yADMzM/MwMDDbBgcHWA8QEIoREhKXDg8Pfw8QEIgRERGZob0MzHPTeIEAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
